import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export interface TablePaginationProps {
  page: number;
  pageSize: number;
  total: number;
  pageSizes?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}
export function TablePagination({
  page,
  pageSize,
  total,
  pageSizes = [25, 50, 100],
  onPageChange,
  onPageSizeChange
}: TablePaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  return <div className="px-4 py-3 border-t border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 gap-3" data-id="element-7778" data-mp="5gmpbvj8qs67">
      <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-7779" data-mp="ov84blz5ysq">
        {total > 0 ? <span data-id="element-7780" data-mp="394y3piztbx0p">
            Resultaat <span className="font-medium text-gray-900" data-id="element-7781" data-mp="39456p9qnolvr">{start}</span>{' '}
            tot <span className="font-medium text-gray-900" data-id="element-7782" data-mp="345lkr9c2ba3e">{end}</span> van{' '}
            <span className="font-medium text-gray-900" data-id="element-7783" data-mp="1isgq22qsif5m">{total}</span>
          </span> : <span data-id="element-7784" data-mp="1nqi4ubh6nsba">Geen resultaten</span>}

        {onPageSizeChange && total > 0 && <div className="flex items-center gap-2 border-l border-gray-200 pl-4" data-id="element-7785" data-mp="1sh8bds1ci17k">
            <span data-id="element-7786" data-mp="1wjbzph9450a9">Rijen per pagina:</span>
            <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} className="bg-transparent font-medium text-gray-900 focus:outline-none cursor-pointer" data-id="element-7787" data-mp="1wiadcgmncrd8">
              {pageSizes.map(size => <option key={size} value={size} data-id="element-7788" data-mp="18thp76c9nnt6">
                  {size}
                </option>)}
            </select>
          </div>}
      </div>

      <div className="flex items-center gap-2" data-id="element-7789" data-mp="2k8y0g954vnkd">
        <span className="text-xs text-gray-500 mr-2" data-id="element-7790" data-mp="2k84ngqfl01ts">
          Pagina {page + 1} van {totalPages}
        </span>
        <div className="flex gap-1" data-id="element-7791" data-mp="2p6g1ldcwsyht">
          <button onClick={() => onPageChange(Math.max(0, page - 1))} disabled={page === 0} className="p-1.5 text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Vorige pagina" data-id="element-7792" data-mp="p5rhh21cfqqe">
            <ChevronLeft className="w-4 h-4" data-id="element-7793" data-mp="u5dv3cl338zq" />
          </button>
          <button onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1 || total === 0} className="p-1.5 text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Volgende pagina" data-id="element-7794" data-mp="6ei94w3b780e">
            <ChevronRight className="w-4 h-4" data-id="element-7795" data-mp="3jtekk2jwp9bp" />
          </button>
        </div>
      </div>
    </div>;
}